"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const SelectUnselect = (props) => {
    const { selected, unselected, handleAction, textField, valueField, displaySelectedText, displayUnselectedText, } = props;
    const [itemList, setItemList] = react_1.useState({
        selected: [],
        unselected: [],
    });
    const [unselectedStyled, setUnselectedStyled] = react_1.useState(null);
    const [selectedStyled, setSelectedStyled] = react_1.useState(null);
    react_1.useEffect(() => {
        setItemList({
            selected: selected,
            unselected: unselected,
        });
    }, [selected, unselected]);
    const callBackToValue = (a, b) => {
        const obj = {
            selected: a,
            unSelected: b,
        };
        handleAction(obj);
    };
    function setSelectState(a, item) {
        const promise = new Promise((resolve, reject) => {
            const filtered = itemList.unselected.filter(e => e[valueField] !== item[valueField]);
            a.push(item);
            const responsePromiseValue = {
                success: true,
                select: a,
                unSelect: filtered,
            };
            setItemList({
                selected: a,
                unselected: filtered,
            });
            resolve(responsePromiseValue);
        });
        return promise;
    }
    function setUnSelectState(a, item) {
        const promise = new Promise((resolve, reject) => {
            const filtered = itemList.selected.filter(e => e[valueField] !== item[valueField]);
            a.push(item);
            const responsePromiseValue = {
                success: true,
                select: filtered,
                unSelect: a,
            };
            resolve(responsePromiseValue);
        });
        return promise;
    }
    const unSelectActionForOneItem = () => {
        if (unselectedStyled !== null) {
            const check = itemList.selected.some(e => e[valueField] === unselectedStyled[valueField]);
            if (!check) {
                setSelectState(itemList.selected, unselectedStyled).then((res) => {
                    if (res.success) {
                        setItemList({
                            selected: res.select,
                            unselected: res.unSelect,
                        });
                        callBackToValue(res.select, res.unSelect);
                        setSelectedStyled(unselectedStyled);
                        setUnselectedStyled(null);
                    }
                });
            }
        }
    };
    const unSelectActionForAllItem = () => {
        itemList.unselected.forEach((item, i) => {
            const check = itemList.selected.some(e => e[valueField] === item[valueField]);
            if (!check) {
                setSelectState(itemList.selected, item).then((res) => {
                    if (res.success) {
                        setItemList({
                            selected: res.select,
                            unselected: [],
                        });
                        callBackToValue(res.select, []);
                        setUnselectedStyled(null);
                    }
                });
            }
        });
    };
    const selectActionForOneItem = () => {
        if (selectedStyled !== null) {
            const check = itemList.unselected.some(e => e[valueField] === selectedStyled[valueField]);
            if (!check) {
                setUnSelectState(itemList.unselected, selectedStyled).then((res) => {
                    if (res.success) {
                        setItemList({
                            selected: res.select,
                            unselected: res.unSelect,
                        });
                        callBackToValue(res.select, res.unSelect);
                        setSelectedStyled(null);
                        setUnselectedStyled(selectedStyled);
                    }
                });
            }
        }
    };
    const selectActionForAllItem = () => {
        itemList.selected.forEach((item, i) => {
            const check = itemList.unselected.some(e => e[valueField] === item[valueField]);
            if (!check) {
                setUnSelectState(itemList.unselected, item).then((res) => {
                    if (res.success) {
                        setItemList({
                            selected: [],
                            unselected: res.unSelect,
                        });
                        callBackToValue([], res.unSelect);
                        setSelectedStyled(null);
                    }
                });
            }
        });
    };
    const handleClickUnselect = (item) => {
        setUnselectedStyled(item);
    };
    const handleClickSelect = (item) => {
        setSelectedStyled(item);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "selectable" },
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement("div", { className: "col-lg-5 unselect" },
                    react_1.default.createElement("div", { className: "row" },
                        react_1.default.createElement("div", { className: "col-lg-12 p-3 pl-4 border-bottom" },
                            react_1.default.createElement("h5", null, displayUnselectedText ? displayUnselectedText : 'Selectable')),
                        itemList.unselected.map(item => {
                            return (react_1.default.createElement("div", { onClick: () => handleClickUnselect(item), className: `col-lg-12 p-3 pl-4 border-bottom ${unselectedStyled !== null &&
                                    unselectedStyled[valueField] === item[valueField]
                                    ? 'selected'
                                    : 'not-selected'}`, key: `${item[valueField]}` }, item[textField]));
                        }))),
                react_1.default.createElement("div", { className: "col-lg-2 icons" },
                    react_1.default.createElement("div", { className: "icon", onClick: () => unSelectActionForAllItem() }, '>>'),
                    react_1.default.createElement("div", { className: "icon", onClick: () => unSelectActionForOneItem() }, '>'),
                    react_1.default.createElement("div", { className: "icon", onClick: () => selectActionForOneItem() }, '<'),
                    react_1.default.createElement("div", { className: "icon", onClick: () => selectActionForAllItem() }, '<<')),
                react_1.default.createElement("div", { className: "col-lg-5 select" },
                    react_1.default.createElement("div", { className: "row" },
                        react_1.default.createElement("div", { className: "col-lg-12 p-3 pl-4 border-bottom" },
                            react_1.default.createElement("h5", null, displaySelectedText ? displaySelectedText : 'Selected')),
                        itemList.selected.map(item => {
                            return (react_1.default.createElement("div", { onClick: () => handleClickSelect(item), className: `col-lg-12 p-3 pl-4 border-bottom ${selectedStyled !== null && selectedStyled[valueField] === item[valueField]
                                    ? 'selected'
                                    : 'not-selected'}`, key: `${item[valueField]}` }, item[textField]));
                        })))))));
};
SelectUnselect.propTypes = {
    selected: prop_types_1.default.arrayOf(prop_types_1.default.any).isRequired,
    unselected: prop_types_1.default.arrayOf(prop_types_1.default.any).isRequired,
    textField: prop_types_1.default.string,
    valueField: prop_types_1.default.string,
    handleAction: prop_types_1.default.func,
};
exports.default = SelectUnselect;
